import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Alignment } from 'src/app/Modules/management/models/organization/alignment.model';

@Component({
    selector: 'app-dynamic-alignment-control',
    templateUrl: './dynamic-alignment-control.component.html',
    styleUrls: ['./dynamic-alignment-control.component.scss'],
    standalone: false
})
export class DynamicAlignmentControlComponent {
    @Input() AlignmentData: Alignment;
    constructor(private ngbActiveModal: NgbActiveModal) {}
    ngOnInit(): void {
        if (!this.AlignmentData) {
            this.AlignmentData = {
                StudBoltsReplaced: false,
                GasketReplaced: true,
                FlangeFaceRepairRequired: true,
                PaintUnderNutRemoved: true,
                CorrectStud: true,
                StudsCorrectlyLubricated: true,
                DataList: [
                    {
                        Name: 'Centreline',
                        ImgUrl: '../../../../../assets/media/logos/centerline-1.png',
                        ZeroDrg: 'Test',
                        NinetyDrg: 'Test',
                        OneEightyDrg: 'Test',
                        TwoSeventyDrg: 'Test',
                    },
                    {
                        Name: 'Separation',
                        ImgUrl: '../../../../../assets/media/logos/seperation-1.png',
                        ZeroDrg: 'Test',
                        NinetyDrg: 'Test',
                        OneEightyDrg: 'Test',
                        TwoSeventyDrg: 'Test',
                    },
                    {
                        Name: 'Gap',
                        ImgUrl: '../../../../../assets/media/logos/gap-1.png',
                        ZeroDrg: 'Test',
                        NinetyDrg: 'Test',
                        OneEightyDrg: 'Test',
                        TwoSeventyDrg: 'Test',
                    },
                    {
                        Name: 'Rotational',
                        ImgUrl: '../../../../../assets/media/logos/rotation-1.png',
                        ZeroDrg: 'Test',
                        NinetyDrg: 'Test',
                        OneEightyDrg: 'Test',
                        TwoSeventyDrg: 'Test',
                    },
                ],
            };
        }
    }
    closeClick() {
        this.ngbActiveModal.close();
    }
}
